/**
 * cart-drawer-empty-state.js
 * ------------------------------------------------------------------
 * Combined file:
 *   1. Restyles the "Your cart is empty" state to match the
 *      drawer's premium navy/gold design (icon, heading, subtext,
 *      pill-shaped Continue Shopping button).
 *   2. Fixes the "Log in" link inside the empty-cart state not
 *      navigating — the drawer's own dialog/focus-trap JS was
 *      intercepting the click before default navigation happened.
 *   3. Fixes mobile: content below "Have an account?" being cut
 *      off / unscrollable. Caused by forcing min-height: 55vh on
 *      the empty state, which pushed the login block past the
 *      visible viewport on short mobile screens with no room left
 *      to scroll. Now uses flexible height + safe-area bottom
 *      padding instead.
 *
 * WHY A SEPARATE FILE:
 * cart-drawer.liquid is left completely untouched. This file only
 * injects styles and lightly enhances existing empty-cart markup
 * (.cart__empty-text, .button, login block) — no existing class or
 * ID is removed, so nothing else can break.
 *
 * HOW TO LOAD:
 * In theme.liquid, just before </body>:
 *   <script src="{{ 'cart-drawer-empty-state.js' | asset_url }}" defer="defer"></script>
 * ------------------------------------------------------------------
 */

(function () {
  if (window.__cartDrawerEmptyStateLoaded) return;
  window.__cartDrawerEmptyStateLoaded = true;

  var STYLE_ID = 'TaravyaEmptyCartStyles';
  var ICON_CLASS = 'taravya-empty-cart-icon';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      /* ---------------------------------------------------
         Base (desktop / tall screens): center everything in
         a comfortable min-height block.
         --------------------------------------------------- */
      '.drawer__inner-empty {',
      '  display: flex;',
      '  flex-direction: column;',
      '  align-items: center;',
      '  justify-content: center;',
      '  padding: 48px 24px 32px;',
      '  min-height: 55vh;',
      '  box-sizing: border-box;',
      '}',

      /* ---------------------------------------------------
         MOBILE FIX:
         Drop the forced min-height so content never gets
         pushed below the visible drawer area, and add real
         breathing room + safe-area padding at the bottom so
         "Have an account? Log in" is always reachable, even
         on short screens / behind the home-indicator area.
         The drawer itself already scrolls (overflow-y: auto
         on .drawer__inner from the base template), so once
         height stops being force-inflated, normal scrolling
         takes over correctly.
         --------------------------------------------------- */
      '@media screen and (max-width: 749px) {',
      '  .drawer__inner-empty {',
      '    min-height: 0;',
      '    height: auto;',
      '    padding: 36px 20px calc(28px + env(safe-area-inset-bottom, 0px));',
      '  }',
      '}',

      '.taravya-empty-cart-icon {',
      '  width: 88px;',
      '  height: 88px;',
      '  border-radius: 50%;',
      '  background: linear-gradient(135deg, #F6F7F9 0%, #EDEFF2 100%);',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  margin-bottom: 22px;',
      '  box-shadow: 0 6px 18px rgba(22,50,74,0.12);',
      '  flex-shrink: 0;',
      '}',

      '.taravya-empty-cart-icon svg {',
      '  width: 40px;',
      '  height: 40px;',
      '}',

      '.cart-drawer__warnings.center {',
      '  text-align: center;',
      '  width: 100%;',
      '}',

      '.cart-drawer__empty-content {',
      '  display: flex;',
      '  flex-direction: column;',
      '  align-items: center;',
      '  width: 100%;',
      '}',

      '.cart__empty-text {',
      '  font-size: 21px !important;',
      '  font-weight: 800 !important;',
      '  color: #16324A !important;',
      '  margin: 0 0 8px !important;',
      '  letter-spacing: -0.2px;',
      '}',

      '.taravya-empty-cart-subtext {',
      '  font-size: 13.5px;',
      '  color: #6B7B8C;',
      '  margin: 0 0 26px;',
      '  font-weight: 500;',
      '  max-width: 260px;',
      '  line-height: 1.5;',
      '}',

      '.drawer__inner-empty .cart-drawer__empty-content > a.button {',
      '  background: #16324A !important;',
      '  color: #F0D9A8 !important;',
      '  border: none !important;',
      '  border-radius: 999px !important;',
      '  padding: 13px 36px !important;',
      '  font-weight: 800 !important;',
      '  font-size: 14.5px !important;',
      '  letter-spacing: 0.3px;',
      '  box-shadow: 0 4px 14px rgba(22,50,74,0.28) !important;',
      '  text-decoration: none !important;',
      '  display: inline-block;',
      '  transition: background .15s ease, transform .15s ease;',
      '  flex-shrink: 0;',
      '}',

      '.drawer__inner-empty .cart-drawer__empty-content > a.button:hover {',
      '  background: #1E4364 !important;',
      '  transform: translateY(-1px);',
      '}',

      '.cart__login-title {',
      '  font-size: 13.5px !important;',
      '  font-weight: 700 !important;',
      '  color: #16324A !important;',
      '  margin: 28px 0 2px !important;',
      '}',

      '.cart__login-paragraph {',
      '  font-size: 12.5px !important;',
      '  color: #6B7B8C !important;',
      '  margin: 0 !important;',
      '  padding-bottom: 4px;',
      '}',

      '.cart__login-paragraph a {',
      '  color: #1B8F5A !important;',
      '  font-weight: 700 !important;',
      '  text-decoration: underline;',
      '  cursor: pointer;',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function buildIcon() {
    var wrap = document.createElement('div');
    wrap.className = ICON_CLASS;
    wrap.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M6 8H18L17 20H7L6 8Z" stroke="#16324A" stroke-width="1.6" stroke-linejoin="round"/>' +
      '<path d="M9 8V6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6V8" stroke="#16324A" stroke-width="1.6" stroke-linecap="round"/>' +
      '<circle cx="12" cy="13" r="1.4" fill="#1B8F5A"/>' +
      '</svg>';
    return wrap;
  }

  function enhanceEmptyState() {
    var container = document.querySelector('.drawer__inner-empty');
    if (!container) return;

    var content = container.querySelector('.cart-drawer__empty-content');
    if (!content) return;

    if (content.querySelector('.' + ICON_CLASS)) return;

    var heading = content.querySelector('.cart__empty-text');
    if (!heading) return;

    content.insertBefore(buildIcon(), heading);

    var subtext = document.createElement('p');
    subtext.className = 'taravya-empty-cart-subtext';
    subtext.textContent = "Looks like you haven't added anything yet. Explore our collections and find something you'll love.";
    heading.insertAdjacentElement('afterend', subtext);
  }

  function run() {
    injectStyles();
    enhanceEmptyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    var observer = new MutationObserver(function () {
      enhanceEmptyState();
    });
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  /* =======================================================
     LOGIN LINK FIX
     The cart drawer's own dialog/focus-trap JS was
     intercepting clicks inside the modal before the <a>
     tag's default navigation could happen. This forces a
     real navigation, bypassing that.
     Runs in capture phase so it fires before the drawer's
     own listeners get a chance to stop it.
     ======================================================= */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.cart__login-paragraph a');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    window.location.href = href;
  }, true);
})();